import { Badge } from '@/components/ui/badge';
import { Loader2, FileText, MinusCircle } from 'lucide-react';
import type { InviteScoreState } from '@/hooks/useTalentDiscoveryMeter';

interface InviteScoreStateBadgeProps {
  state: InviteScoreState | undefined;
}

export function InviteScoreStateBadge({ state }: InviteScoreStateBadgeProps) {
  if (!state || !state.accepted_application_id) return null;

  if (state.score_state === 'processing') {
    return (
      <Badge variant="outline" className="rounded-lg text-[10px] gap-1">
        <Loader2 className="w-3 h-3 animate-spin" />
        Scoring...
      </Badge>
    );
  }

  if (state.score_state === 'ready' && state.total_score !== null) {
    return (
      <Badge variant="secondary" className="rounded-lg text-[10px] gap-1">
        <FileText className="w-3 h-3" />
        AI {state.total_score}%
      </Badge>
    );
  }

  if (state.score_state === 'unavailable') {
    return (
      <Badge variant="outline" className="rounded-lg text-[10px] gap-1 text-muted-foreground">
        <MinusCircle className="w-3 h-3" />
        Score unavailable
      </Badge>
    );
  }

  return null;
}
